module.exports = __webpack_public_path__ + "static/media/google-ads.10a3e424.svg";